/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */

export const deleteAccountRedirect = ({ router, route }) => {
  const redirectionName = route.params?.redirection?.name

  if (redirectionName === 'settings.booksy-app.delete-your-account') {
    return router.push({ name: redirectionName })
  }
}
